const LAST_ACTIVITY_KEY = 'lastActivityAt';
const DEFAULT_IDLE_TIMEOUT_MS = 30 * 60 * 1000;

let listenersAttached = false;

function getIdleTimeoutMs() {
  const configured = Number(process.env.REACT_APP_IDLE_TIMEOUT_MS);
  return Number.isFinite(configured) && configured > 0
    ? configured
    : DEFAULT_IDLE_TIMEOUT_MS;
}

export function touchActivity() {
  const now = Date.now();
  sessionStorage.setItem(LAST_ACTIVITY_KEY, String(now));
  return now;
}

export function getLastActivityAt() {
  const raw = sessionStorage.getItem(LAST_ACTIVITY_KEY);
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

export function isUserIdle() {
  const lastActivity = getLastActivityAt();
  if (lastActivity == null) {
    return true;
  }

  return Date.now() - lastActivity >= getIdleTimeoutMs();
}

export function startIdleTracker() {
  if (typeof window === 'undefined' || listenersAttached) {
    return;
  }

  touchActivity();

  const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
  const onActivity = () => {
    touchActivity();
  };

  events.forEach((eventName) => {
    window.addEventListener(eventName, onActivity, { passive: true });
  });

  listenersAttached = true;
}
